<app-navbar [type]="navbarTypeEnum.LANDING" [isCheckout]="false" />
<section class="body-font relative flex flex-col justify-center items-center">
  <div
    class="sm:px-2 sm:py-4 justify-center self-center flex sm:flex-nowrap flex-wrap"
  >
    <div
      class="shadow-xl mx-auto sm:rounded-3xl bg-surface overflow-hidden flex relative"
    >
      <div class="w-full h-full max-w-7xl">
        <div class="flex flex-col items-start h-fit px-4 sm:px-16 py-8">
          <h1
            class="text-4xl font-bold pb-8 border-b-4 border-primary w-full pl-16 -ml-16"
          >
            Políticas.
          </h1>
          <div class="my-4 ml-1">
            <ml-breadcrumb [items]="breadcrumbItems" />
          </div>
          <p class="text-lg mt-6">
            A continuación encontrarás desglosada toda la información sobre
            nuestros Términos y Condiciones, Condiciones de Uso, Declaración de
            Privacidad, Política de Cookies y la Política del Asistente Virtual
            (IA).
          </p>
          <div class="pt-12 md:pt-10">
            <div class="px-3 md:container">
              <div class="lg:flex">
                <div class="items-center lg:hidden">
                  <select
                    (change)="onSelectOption($event)"
                    [(ngModel)]="selectedOption"
                    class="mx-2 mb-8 px-4.5 py-2.5 rounded-md h-full w-[-webkit-fill-available] text-xl focus:ring-2 focus:ring-inset focus:ring-primary block border-0 bg-bg text-fg shadow-sm ring-1 ring-inset ring-border-strong"
                  >
                    <option
                      class="text-base"
                      value="/politicas/terminos-y-condiciones"
                    >
                      Terminos y Condiciones
                    </option>
                    <option value="/politicas/condiciones-de-uso">
                      Condiciones de Uso
                    </option>
                    <option value="/politicas/privacidad">Privacidad</option>
                    <option value="/politicas/cookies">Cookies</option>
                    <option value="/politicas/agente-ia">
                      Asistente Virtual (IA)
                    </option>
                  </select>
                </div>
                <div class="left-flex hidden lg:block mr-10 mb-10">
                  <div class="mt-3 px-6">
                    <a
                      routerLink="terminos-y-condiciones"
                      routerLinkActive="font-bold text-primary"
                      aria-current="page"
                      class="ota-body-light nuxt-link-exact-active nuxt-link-active"
                    >
                      Terminos y Condiciones
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="condiciones-de-uso"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Condiciones de Uso
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="/politicas/privacidad"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Privacidad
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="cookies"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Cookies
                    </a>
                  </div>
                  <div class="mt-3 px-6">
                    <a
                      routerLink="agente-ia"
                      routerLinkActive="font-semibold text-primary"
                      class="ota-body-light"
                    >
                      Asistente Virtual (IA)
                    </a>
                  </div>
                </div>
                <div class="flex">
                  <div class="mx-auto sm:max-w-2xl px-2 lg:px-8">
                    <router-outlet></router-outlet>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer />
